export const DEFAULT_GROUP_ID = "default_group";
